import { Amplify } from 'aws-amplify';
import config from './appConfig';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: config.cognito.userPoolId,
      userPoolClientId: config.cognito.clientId,
      identityPoolId: config.cognito.identityPoolId,
      loginWith: {
        oauth: {
          domain: `branq-${config.env}-userpool.auth.ap-northeast-1.amazoncognito.com`,
          scopes: ['email', 'openid', 'profile'],
          redirectSignIn: [`${config.url.customerWeb}/proxy/callback/`],
          redirectSignOut: [`${config.url.customerWeb}/`],
          responseType: 'code',
        },
      },
    },
  },
  API: {
    REST: {
      'admin-api': {
        endpoint: config.apiGateway.endpoint,
        region: config.apiGateway.region,
      },
    },
  },
});
